import { render, staticRenderFns } from "./SearchBarV2.vue?vue&type=template&id=856fb3ca"
import script from "./SearchBarV2.vue?vue&type=script&lang=js"
export * from "./SearchBarV2.vue?vue&type=script&lang=js"
import style0 from "./SearchBarV2.vue?vue&type=style&index=0&id=856fb3ca&prod&lang=css"
import style1 from "./SearchBarV2.vue?vue&type=style&index=1&id=856fb3ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports